export { default as PencilAltOutlineIcon } from './PencilAltOutlineIcon';
